import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CAlert, CButton, CCard, CCardBody, CCol, CContainer, CRow, CSpinner } from '@coreui/react-pro'

import { api, ApiError, type AuthUser } from '../api/client'
import { AuthContext } from '../App'

const Activate: React.FC = () => {
  const [search] = useSearchParams()
  const navigate = useNavigate()
  const { setUser } = useContext(AuthContext)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(true)
  const token = search.get('token') ?? ''
  const next = search.get('next') || '/'

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      if (!token) {
        if (!cancelled) { setError('No invite token in this link.'); setBusy(false) }
        return
      }
      try {
        // The response IS the session user — set it directly instead of
        // refetching /me, which can race the browser committing the cookie.
        const user = await api.post<AuthUser>('/v1/auth/activate', { token })
        if (!cancelled) {
          setUser(user)
          navigate(next, { replace: true })
        }
      } catch (err) {
        if (cancelled) return
        const code = err instanceof ApiError ? err.code : 'UNKNOWN'
        if (code === 'RATE_LIMITED') setError('Too many attempts — wait a minute and reopen your link.')
        else if (code === 'INVALID_INVITE') setError('This link is invalid or expired. Text Paul for a fresh one.')
        else setError('Activation failed. Try reopening your link.')
        setBusy(false)
      }
    })()
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCard className="p-4">
              <CCardBody className="text-center">
                <div style={{ fontSize: 48 }}>🌴</div>
                <h4>Costa Rica 2027</h4>
                {busy && (
                  <>
                    <CSpinner className="mt-3" />
                    <p className="text-body-secondary mt-3">Signing you in…</p>
                  </>
                )}
                {error && (
                  <>
                    <CAlert color="danger" className="mt-3">{error}</CAlert>
                    <CButton color="primary" variant="outline" className="mt-2" href="/login">
                      Back
                    </CButton>
                  </>
                )}
                <p className="text-body-secondary small mt-4">
                  Tip: bookmark this page — your link is your login.
                </p>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Activate
